import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('workflow_settings'),
    saveButton: defineMessage('save_changes'),
    saveButtonTitle: defineMessage('save_the_templatename_workflow_settings'),
    requiredFieldsNotification: defineMessage('please_fill_in_all_required_fields'),
    generalTab: defineMessage('general'),
    matchingTab: defineMessage('matching'),
    fraudDetectionTab: defineMessage('fraud_detection'),
    emailToSupplierTab: defineMessage('email_to_supplier_1'),
    emailToVendorTab: defineMessage('email_to_vendor'),
    emailToCustomerTab: defineMessage('email_to_customer_1'),
    captureTab: defineMessage('capture'),
};
